// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"89fc311d","561":"cb5c3400","788":"14fa4914","830":"76456ba9","981":"6dae58a6"}[chunkId] + ".chunk.js";
};